export default class CookieSettings {
    constructor() {
        window.addEventListener('load', () => {
            setTimeout(() => {
                // link with cookie  hash
                const cookieSettingsLink = document.querySelectorAll('[href="#cookie-settings"]');
                this.cookieSettingsButton = document.querySelector('#CookiebotWidget .CookiebotWidget-logo');
                if (cookieSettingsLink.length > 0) {
                    cookieSettingsLink.forEach((link) => {
                        link.addEventListener('click', (event) => {
                            event.preventDefault();
                            this.openCookieSettings();
                        });
                    });
                }
            }, 1000);
        });
    }
    openCookieSettings() {
        var _a;
        (_a = this.cookieSettingsButton) === null || _a === void 0 ? void 0 : _a.click();
    }
}
